import React from 'react'
import { SectionWrapperProps } from './types'
import './index.scss'

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ children }) => {
  return <div className={`section-wrapper ${React.Children.count(children) === 1 ? 'full' : 'half'}`}>{children}</div>
}
